// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ENABLE_ADS_MESSAGE = "Zpr\u00e1va obsahuje slevu nebo speci\u00e1ln\u00ed nab\u00eddku. Povol reklamy, abys mohla vid\u011bt v\u0161echny slevy a speci\u00e1ln\u00ed akce, kter\u00e9 pos\u00edl\u00e1me u\u017eivatelk\u00e1m Modr\u00e9ho kon\u00edka.";
